import "./page-outreach-program.scss";
import "../../js/core";

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(()=>{
      $(".slider-card-quote").owlCarousel({
        responsive: {
          0: {
            items: 1,
          },
          820: {
            items: 2,
          },
        },
        slideBy: 1,
        dots: false,
        nav: true,
        loop: false,
        margin: 24,
        smartSpeed: 200,
      });
      
      $('.owl-carousel').each(function(index) {
          $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
      });
    });
  });
});

$(function () {
  $(document).on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();
    
    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 0
    }, 800);
  });
  return false;
});

$( document ).ready(function() {
  $('.form-upload-file').each(function () {
    let fileInput = $(this).find('input[type="file"]');
    let fileInfo = $(this).find('.file-info');
    let fileNameTag = $(this).find('.file-name');
    let fileSizeTag = $(this).find('.file-size');
    let buttonClear = $(this).find('.clear');
    
    fileInput.on('change', function (e) {
      let selectedFile = e.target.files[0];
      let fileSize;
      
      if (selectedFile) {
        if(selectedFile.size >= 1048576) {
          fileSize = '(' + (selectedFile.size / (1024 * 1024)).toFixed(2) + 'mb)';
        }
        else {
          fileSize = '(' + (selectedFile.size / 1024).toFixed(2) + 'kb)';
        }
        fileNameTag.html('<span class="name">' + selectedFile.name.split('.').slice(0, -1).join('.') + '</span><span class="type">.' + selectedFile.type.split('/')[1]  + '</span>');
        fileSizeTag.text(fileSize);
        fileInfo.css('display', 'flex');
      }
      
      buttonClear.on('click', function() {
        fileInput.val('');
        fileNameTag.html('');
        fileSizeTag.text('');
        fileInfo.css('display', '');
    });
    });
  });
  
  $('.modal-shedule-demo').on('hide.bs.modal', function () {
    $('.file-info').css('display', '');
  });
});